import { useLanguage } from "@/lib/i18n";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useLanguage();
  const isDE = lang === "de";
  return (
    <div
      data-testid="lang-toggle"
      className={`inline-flex items-center overflow-hidden border border-white/15 ${className}`}
    >
      <button
        type="button"
        onClick={() => setLang("de")}
        data-testid="lang-de"
        aria-pressed={isDE}
        className={`mono px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] transition-colors ${
          isDE ? "bg-[#FF4B00] text-white" : "bg-transparent text-white/60 hover:text-white"
        }`}
      >
        DE
      </button>
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="lang-en"
        aria-pressed={!isDE}
        className={`mono px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] transition-colors ${
          !isDE ? "bg-[#FF4B00] text-white" : "bg-transparent text-white/60 hover:text-white"
        }`}
      >
        EN
      </button>
    </div>
  );
}
